import { createRoute, redirect, type AnyRoute } from "@tanstack/react-router";
import { Calculator } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { currentMonth } from "./api";
import { CosUnitsPage } from "./pages/CosUnitsPage";

export const cosUnitsModule: FeatureModule = {
  key: "cos_units",
  nav: {
    label: "COS — Units",
    icon: Calculator,
    to: "/cos-units",
    requires: "cos_units.read",
    order: 40,
    group: "Finance",
  },
  routes: (rootRoute) => [
    // Bare /cos-units → the current month.
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cos-units",
      beforeLoad: () => {
        throw redirect({
          to: "/cos-units/$period",
          params: { period: currentMonth() },
        });
      },
      component: () => null,
    }),
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/cos-units/$period",
      component: guarded("cos_units.read", CosUnitsPage),
    }),
  ] as unknown as AnyRoute[],
};
